import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { translations } from "./i18n";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

const LangCtx = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("dc_lang") || "it");
  useEffect(() => { localStorage.setItem("dc_lang", lang); }, [lang]);
  const t = useCallback((path) => {
    return path.split(".").reduce((o, k) => (o ? o[k] : undefined), translations[lang]) ?? path;
  }, [lang]);
  return <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>;
}

export const useLang = () => useContext(LangCtx);
